import React from "react";
import AttendanceSubmissionList from "../../features/AttendanceSubmission/AttendanceSubmissionList";

const AttendanceSubmissionApprovalList = () => {
  return (
    <div>
      <AttendanceSubmissionList />
    </div>
  );
};

export default AttendanceSubmissionApprovalList;
